import { PRODUCTION_LARGE, PRODUCTION_SMALL, VIOLET } from "./buildingTypes"

const initialState = {
  vpChips: 0,
  buildings: [
    {
      name: "Small Indigo Plant",
      type: PRODUCTION_SMALL,
      points: 1,
      isBuilt: false,
      hasWorker: null,
      bonusInput: null,
    },
    {
      name: "Small Sugar Mill",
      type: PRODUCTION_SMALL,
      points: 1,
      isBuilt: false,
      hasWorker: null,
      bonusInput: null,
    },
    {
      name: "Small Market",
      type: VIOLET,
      points: 1,
      isBuilt: false,
      hasWorker: null,
      bonusInput: null,
    },
    {
      name: "Hacienda",
      type: VIOLET,
      points: 1,
      isBuilt: false,
      hasWorker: null,
      bonusInput: null,
    },
    {
      name: "Construction Hut",
      type: VIOLET,
      points: 1,
      isBuilt: false,
      hasWorker: null,
      bonusInput: null,
    },
    {
      name: "Small Warehouse",
      type: VIOLET,
      points: 1,
      isBuilt: false,
      hasWorker: null,
      bonusInput: null,
    },
    {
      name: "Indigo Plant",
      type: PRODUCTION_LARGE,
      points: 2,
      isBuilt: false,
      hasWorker: null,
      bonusInput: null,
    },
    {
      name: "Sugar Mill",
      type: PRODUCTION_LARGE,
      points: 2,
      isBuilt: false,
      hasWorker: null,
      bonusInput: null,
    },
    {
      name: "Hospice",
      type: VIOLET,
      points: 2,
      isBuilt: false,
      hasWorker: null,
      bonusInput: null,
    },
    {
      name: "Office",
      type: VIOLET,
      points: 2,
      isBuilt: false,
      hasWorker: null,
      bonusInput: null,
    },
    {
      name: "Large Market",
      type: VIOLET,
      points: 2,
      isBuilt: false,
      hasWorker: null,
      bonusInput: null,
    },
    {
      name: "Large Warehouse",
      type: VIOLET,
      points: 2,
      isBuilt: false,
      hasWorker: null,
      bonusInput: null,
    },
    {
      name: "Tobacco Storage",
      type: PRODUCTION_LARGE,
      points: 3,
      isBuilt: false,
      hasWorker: null,
      bonusInput: null,
    },
    {
      name: "Coffee Roaster",
      type: PRODUCTION_LARGE,
      points: 3,
      isBuilt: false,
      hasWorker: null,
      bonusInput: null,
    },
    {
      name: "Factory",
      type: VIOLET,
      points: 3,
      isBuilt: false,
      hasWorker: null,
      bonusInput: null,
    },
    {
      name: "University",
      type: VIOLET,
      points: 3,
      isBuilt: false,
      hasWorker: null,
      bonusInput: null,
    },
    {
      name: "Harbor",
      type: VIOLET,
      points: 3,
      isBuilt: false,
      hasWorker: null,
      bonusInput: null,
    },
    {
      name: "Wharf",
      type: VIOLET,
      points: 3,
      isBuilt: false,
      hasWorker: null,
      bonusInput: null,
    },
    {
      name: "Guild Hall",
      type: VIOLET,
      points: 4,
      isBuilt: false,
      hasWorker: false,
      bonusInput: null,
    },
    {
      name: "Customs House",
      type: VIOLET,
      points: 4,
      isBuilt: false,
      hasWorker: false,
      bonusInput: null,
    },
    {
      name: "Residence",
      type: VIOLET,
      points: 4,
      isBuilt: false,
      hasWorker: false,
      bonusInput: {
        inputId: "islandSpaces",
        value: "",
        labelText: "Total occupied island spaces",
        inputPlaceholder: "Island spaces"
      },
    },
    {
      name: "City Hall",
      type: VIOLET,
      points: 4,
      isBuilt: false,
      hasWorker: false,
      bonusInput: null,
    },
    {
      name: "Fortress",
      type: VIOLET,
      points: 4,
      isBuilt: false,
      hasWorker: false,
      bonusInput: {
        inputId: "totalWorkers",
        value: "",
        labelText: "Total number of workers",
        inputPlaceholder: "Total workers"
      },
    }
  ]
}

export default initialState;
